(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smiley-home-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smiley-home-motion')) {
    customElements.define('smiley-home-motion', class extends HTMLElement {
      connectedCallback() {
        this.main = this.closest('main');
        this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.refresh = () => {
          const enabled = this.dataset.motionEnabled === 'true' && !this.preference.matches;
          this.main?.classList.toggle('smiley-motion-active', enabled);
          this.observer?.disconnect();
          this.main?.querySelectorAll('.smiley-reveal--enter').forEach(el => el.classList.remove('smiley-reveal--enter'));
          if (!enabled || !this.main || !('IntersectionObserver' in window)) return;
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('smiley-reveal--enter');
                this.observer.unobserve(entry.target);
              }
            });
          }, { threshold: .08 });
          this.main.querySelectorAll(':scope > .shopify-section').forEach(el => {
            if (el.contains(this) || el.getBoundingClientRect().top < window.innerHeight) return;
            el.classList.add('smiley-reveal');
            this.observer.observe(el);
          });
        };
        this.preference.addEventListener('change', this.refresh);
        this.frame = requestAnimationFrame(this.refresh);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.preference?.removeEventListener('change', this.refresh);
        this.main?.classList.remove('smiley-motion-active');
        this.main?.querySelectorAll('.smiley-reveal--enter').forEach(el => el.classList.remove('smiley-reveal--enter'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
